import { chain, get } from "lodash"
import { ReduxState, Role } from "model/state"
import { createSelector } from "reselect"

const getSelectedAccountID = (state: ReduxState) => get(state, "global.selected.accountId")
const getUserAccounts = (state: ReduxState) => get(state, "user.accounts")
const getIsSuperuser = (state: ReduxState) => get(state, "user.isSuperuser", false)

export const getRole = createSelector(
  [getSelectedAccountID, getUserAccounts, getIsSuperuser],
  (accountId, userAccounts, isSuperuser): Role => {
    if (isSuperuser) {
      return "admin"
    }

    return chain(userAccounts)
      .find(account => account.accountId === accountId)
      .get("role")
      .value()
  },
)
